<template>
  <v-content>
    <v-container id="principal" grid-list-md>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'AppMain'
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#principal {
  /*fade*/
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
}
</style>
